// src/components/TravelInspiration/InspirationCard.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const InspirationCard = ({ image, categoryKey }) => {
  const { t } = useTranslation(); // 3. Initialize t() function

  return (
    <Box className="card-container">
      <img src={image} alt={t(categoryKey)} className="card-image" />
      <Box className="card-overlay">
        <Typography variant="h4" className="card-category" fontWeight={700}>
          {t(categoryKey)}
        </Typography>
      </Box>
    </Box>
  );
};

export default InspirationCard;